import { PipeTransform } from '@angular/core';
var FacetValuesPipe = /** @class */ (function () {
    function FacetValuesPipe() {
    }
    FacetValuesPipe.prototype.transform = function (values, facetcode, combinedFacets) {
        if (values && values.length > 0 && combinedFacets && combinedFacets.facets[facetcode] && combinedFacets.facets[facetcode].length) {
            var facets = values.filter(function (value) { return value.startsWith(facetcode + '='); });
            var facetValues = '';
            var _loop_1 = function (foundFacet) {
                var value = combinedFacets.facets[facetcode].find(function (facet) { return facet.code === foundFacet; });
                if (value && value.name) {
                    facetValues += value.name + ', ';
                }
            };
            for (var _i = 0, facets_1 = facets; _i < facets_1.length; _i++) {
                var foundFacet = facets_1[_i];
                _loop_1(foundFacet);
            }
            if (facetValues && facetValues.endsWith(', ')) {
                facetValues = facetValues.substr(0, facetValues.length - 2);
                return facetValues;
            }
        }
        return '';
    };
    return FacetValuesPipe;
}());
export { FacetValuesPipe };
